import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersEmployeeConditionSubmissionsCreateRequestType,
  ApiMembersEmployeeConditionSubmissionsCreateResponseType,
} from "~/domains";

type RequestDataType = {
  employeeConditionSurveyId: string;
  body: ApiMembersEmployeeConditionSubmissionsCreateRequestType;
};

const request = ({ employeeConditionSurveyId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiMembersEmployeeConditionSubmissionsCreateResponseType>(
      `/api/members/employee_condition_surveys/${employeeConditionSurveyId}/employee_condition_submissions`,
      {
        employeeConditionSubmission: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApiMembersEmployeeConditionSubmissionsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersEmployeeConditionSubmissionsCreateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
